import React, { useEffect, useState } from 'react';
import api from '../services/api';
import './FoodGallery.css';

const TABS = [
  { key: 'breakfast', ro: 'Mic dejun', en: 'Breakfast', de: 'Frühstück', fr: 'Petit-déjeuner' },
  { key: 'lunch',     ro: 'Prânz',     en: 'Lunch',     de: 'Mittagessen', fr: 'Déjeuner' },
  { key: 'dinner',    ro: 'Cină',      en: 'Dinner',     de: 'Abendessen', fr: 'Dîner' },
  { key: 'specialty', ro: 'Specialități', en: 'Specialties', de: 'Spezialitäten', fr: 'Spécialités' },
];

// Size pattern for puzzle layout: lg=2×2, tall=1×2, wide=2×1, sm=1×1
const PUZZLE_SIZES = ['lg', 'sm', 'sm', 'tall', 'sm', 'wide', 'sm', 'sm', 'tall', 'sm'];

export default function FoodGallery({ compact = false, lang = 'ro' }) {
  const [items, setItems] = useState([]);
  const [activeTab, setActiveTab] = useState('breakfast');
  const [lightbox, setLightbox] = useState(null); // { url, caption }

  useEffect(() => {
    if (compact) {
      api.get('/food-gallery?featured=1').then(res => setItems(res.data || [])).catch(() => {});
    } else {
      api.get('/food-gallery').then(res => setItems(res.data || [])).catch(() => {});
    }
  }, [compact]);

  if (compact) {
    if (items.length === 0) {
      return (
        <div className="food-gallery food-gallery--compact food-gallery--placeholder">
          <div className="food-gallery__puzzle food-gallery__puzzle--placeholder">
            {[...Array(6)].map((_, i) => (
              <div
                key={i}
                className={`food-gallery__puzzle-item food-gallery__puzzle-item--${PUZZLE_SIZES[i] || 'sm'}`}
              />
            ))}
          </div>
        </div>
      );
    }
    return (
      <div className="food-gallery food-gallery--compact">
        <div className="food-gallery__puzzle">
          {items.map((img, i) => {
            const size = PUZZLE_SIZES[i % PUZZLE_SIZES.length];
            return (
              <div
                key={img.id}
                className={`food-gallery__puzzle-item food-gallery__puzzle-item--${size}`}
                data-idx={i}
                onClick={() => setLightbox({ url: img.image_url, caption: img.caption })}
              >
                <img src={img.image_url} alt={img.caption || ''} loading="lazy" />
                {img.caption && (
                  <span className="food-gallery__puzzle-caption">{img.caption}</span>
                )}
              </div>
            );
          })}
        </div>

        {lightbox && (
          <div className="food-gallery__lightbox" onClick={() => setLightbox(null)}>
            <div className="food-gallery__lightbox-card" onClick={e => e.stopPropagation()}>
              <button className="food-gallery__lightbox-close" onClick={() => setLightbox(null)}>✕</button>
              <img src={lightbox.url} alt={lightbox.caption || ''} />
              {lightbox.caption && <p className="food-gallery__lightbox-caption">{lightbox.caption}</p>}
            </div>
          </div>
        )}
      </div>
    );
  }

  const filtered = items.filter(i => i.category === activeTab);

  return (
    <div className="food-gallery">
      <div className="food-gallery__tabs">
        {TABS.map(t => (
          <button
            key={t.key}
            className={`food-gallery__tab${activeTab === t.key ? ' food-gallery__tab--active' : ''}`}
            onClick={() => setActiveTab(t.key)}
          >
            {t[lang] || t.ro}
          </button>
        ))}
      </div>
      <div className="food-gallery__grid">
        {filtered.map(img => (
          <div key={img.id} className="food-gallery__item">
            <img src={img.image_url} alt={img.caption || ''} loading="lazy" />
            {img.caption && <span className="food-gallery__caption">{img.caption}</span>}
          </div>
        ))}
        {filtered.length === 0 && (
          <p className="food-gallery__empty">–</p>
        )}
      </div>
    </div>
  );
}
